import { useEffect, useMemo, useRef } from 'react';

import qs from 'qs';
import { useInstantSearch } from 'react-instantsearch';
import { useLocation } from 'react-router';

import { SEARCH_QUERY_KEYS, SEARCH_UI_STATE_KEYS } from 'src/app/pages/search/shared/types';

type Props = {
	resetFilters: () => void;
};

export function useResetFiltersOnSamePageNavigation({ resetFilters }: Props): void {
	const location = useLocation();
	const { indexUiState } = useInstantSearch();

	const prevPath = useRef<string>(location.pathname);
	const isFirstRender = useRef<boolean>(true);

	const hasFiltersApplied = useMemo(() => {
		const hasFilters = Object.keys(indexUiState).some((key) => SEARCH_UI_STATE_KEYS.includes(key));

		return hasFilters;
	}, [indexUiState]);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}
		if (!hasFiltersApplied) {
			return;
		}

		const query = qs.parse(location.search, { ignoreQueryPrefix: true });
		const hasQueryParams = Object.keys(query).some((key) => SEARCH_QUERY_KEYS.includes(key));

		if (hasQueryParams) {
			return;
		}

		const currentPath = location.pathname;

		if (prevPath.current === currentPath) {
			resetFilters();
		}
		prevPath.current = currentPath;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);
}
